<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Coleta de exame laboratorial"
    >
        <template v-if="agendamentos.length > 0">
            <rkm-row>
                <rkm-col>
                    <template>
                        <rkm-button @click="imprimirEtiquetas()">
                            Imprimir etiqueta(s)
                        </rkm-button>
                    </template>

                    <template>
                        <rkm-button
                            @click="atribuirTodosComoRealizado()"
                            color="info"
                        >
                            Atribuir todos como realizado
                        </rkm-button>
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-table
                v-for="(agendamento, i) in agendamentos"
                :fields="fields"
                :items="agendamento.exames"
                :key="i"
                class="mt-2"
                hide-filters
                hide-pagination
            >
                <template #thead-top>
                    <rkm-tr>
                        <rkm-th :colspan="fields.length - 2">
                            Unidade solicitante: {{ agendamento.unidadeNome }}
                        </rkm-th>

                        <rkm-th>
                            Local de atendimento: {{ agendamento.infraestruturaNome }}
                        </rkm-th>

                        <rkm-th></rkm-th>
                    </rkm-tr>

                    <rkm-tr>
                        <rkm-th :colspan="fields.length - 1">
                            Médico: {{ agendamento.medicoNome }}
                        </rkm-th>

                        <rkm-th class="col-min text-center">
                            Agendamento: {{ agendamento.agendamentoNumero }}
                        </rkm-th>
                    </rkm-tr>
                </template>

                <template v-slot:cell(status)="{ item }">
                    <rkm-form-select
                        :options="data.form.status"
                        @change="() => item.statusId !== enums.statusAgendamento.REALIZADO
                            && (item.usuarioId = null)"
                        class="pt-0 mb-0"
                        textField="descricao"
                        v-model="item.statusId"
                        valueField="id"
                    />
                </template>

                <template v-slot:cell(usuarioId)="{ item }">
                    <rkm-form-select
                        :disabled="item.statusId !== enums.statusAgendamento.REALIZADO"
                        :options="usuariosFaturamento"
                        @change="handleOcupacao(item)"
                        class="pt-0 mb-0"
                        show-default-option
                        textField="usuarioOcupacao"
                        v-model="item.usuarioId"
                        valueField="id"
                    />
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="imprimirEtiqueta(agendamento, item)"
                        small
                        title="Imprimir etiqueta"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalDetalhamento.open(agendamento, item)"
                        color="primary"
                        small
                        title="Detalhamento"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>

            <ModalDetalhamento ref="ModalDetalhamento" />
        </template>

        <rkm-alert
            v-else
            color="info"
        >
            Nenhuma coleta agendada para o dia atual.
        </rkm-alert>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ModalDetalhamento from './components/detalhamento/Modal'

// Mixins.
import { object, data, printExameLaboratorial } from '@/mixins'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { ModalDetalhamento },
    computed: {
        fields() {
            const fields = [
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                },
            ]

            if (this.usuariosFaturamento.length > 1) {

                fields.push({
                    key: 'usuarioId',
                    label: 'Profissional - CBO',
                })
            }

            fields.push(
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            )

            return fields
        },
        usuariosFaturamento() {

            let usuarios = []

            this.data.form.unidadesFaturamento.forEach(item => {

                if (item.infraestruturaId == this.data.model.coletaInfraestruturaId) {

                    usuarios.push(item.usuario)
                }

                item.faturamentoRelacionado.forEach(relacionado => {

                    if (relacionado.relacionadaInfraestruturaId == this.data.model.coletaInfraestruturaId) {

                        usuarios.push(item.usuario)
                    }
                })
            })

            if (usuarios.length == 1) {

                this.handleUsuario(usuarios)
            }

            return usuarios
        },
    },
    data: () => ({
        agendamentos: [],
        enums: {
            statusAgendamento,
            preferenciaNome
        },
    }),
    methods: {
        open() {

            this.agendamentos = this.clone(this.data.model.agendamentos)

            this.$refs.RkmModal.show()
        },
        save() {

            if (!this.isValidUsuariosFaturamento()) {

                this.showAlert('É obrigatório selecionar o profissional para cada exame realizado.')

                return false
            }

            this.data.model.agendamentos = this.clone(this.agendamentos)

            this.$refs.RkmModal.hide()
        },
        isValidUsuariosFaturamento() {

            let valid = true

            if (this.usuariosFaturamento.length > 1) {

                this.agendamentos.forEach(agendamento => {

                    agendamento.exames.forEach(exame => {

                        if (exame.statusId == this.enums.statusAgendamento.REALIZADO && !exame.usuarioId) {

                            valid = false
                        }
                    })
                })
            }

            return valid
        },
        atribuirTodosComoRealizado() {

            this.showConfirmation(
                'Todos os exames serão atribuídos como REALIZADO. Deseja continuar?',
                async () => this.agendamentos.forEach(item => {

                    item.exames.forEach(exame => {

                        exame.statusId = this.enums.statusAgendamento.REALIZADO
                    })
                })
            )
        },
        imprimirEtiquetas() {

            this.print().etiquetaColeta(this.agendamentos, this.data.form.sistema, this.data.form.unidade)
        },
        imprimirEtiqueta(agendamento, item) {

            this.print().etiquetaColetaIndividual(agendamento, item, this.data.form.sistema, this.data.form.unidade)
        },
        handleOcupacao(item) {

            this.data.form.unidadesFaturamento.forEach(faturamento => {

                if (faturamento.usuario.id == item.usuarioId) {

                    item.ocupacaoId = faturamento.usuario.ocupacaoId
                }
            })
        },
        handleUsuario(usuarios) {

            usuarios.map(usuario => {

                this.agendamentos.forEach(agendamento => {

                    agendamento.exames.forEach(exame => {

                        exame.usuarioId = usuario.id
                        exame.ocupacaoId = usuario.ocupacaoId
                    })
                })
            })
        },
    },
    mixins: [object, data, printExameLaboratorial],
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
thead > tr {
    line-height: 15px;
}
</style>